import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ISection } from 'interfaces-lib';

export class SignatureOutputFileTypeBuilder {
  public static buildForm(formGroup: UntypedFormGroup, section?: ISection): void {
    formGroup.get('sourceType').setValue('TXT');
    formGroup.get('referenceId').setValue(section?.referenceId ?? 'SIGNATURE_OUTPUT_FILETYPE_1');
    formGroup.addControl('validTypeSelected', new UntypedFormControl(true, SignatureOutputFileTypeBuilder.validateDocumentType));
  }

  public static validateDocumentType(control: AbstractControl): ValidationErrors | null {
    const valid = control.value;
    return valid ? null : { invalidDocumentType: true };
  }
}
